import { Languages } from "src/common/descriptions/types";
import { CreateExpenditureRecordDescriptions } from "./types";

const DescriptionsEnUs: CreateExpenditureRecordDescriptions = {
    TITLE: "Create Expenditure Record",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save Record?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Record input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Record Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Record Updated",
    },
    FORM: {
        DESCRIPTION: {
            LABEL: "Description",
            PLACEHOLDER: "Input description",
        },
        CATEGORY: {
            LABEL: "Category",
            PLACEHOLDER: "Select category",
        },
        ORIGIN: {
            LABEL: "Origin",
            PLACEHOLDER: "Select origin",
        },
        TOTAL: {
            LABEL: "Total",
            PLACEHOLDER: "0.00",
        },
        SERVICE_CATEGORY: {
            LABEL: "Service Category",
            PLACEHOLDER: "Select Service Category",
        },
    },
    MAIN_ACTION_TITLE: "Creating Record",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    BALANCE: "Balance:",
    CASHBOX: "Cashbox",
    BANK: "Bank",
    AMOUNT_MUST_BE_GT_BALANCE: "Amount must be lower or equal to cashbox balance",
}

const DescriptionsEsUs: CreateExpenditureRecordDescriptions = {
    TITLE: "Crear Registro de Gasto",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Registro con los datos ingresados?',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Registro?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Regisro creado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Registro Actualizado",
    },
    FORM: {
        DESCRIPTION: {
            LABEL: "Descripción",
            PLACEHOLDER: "Ingresa descripción",
        },
        CATEGORY: {
            LABEL: "Categoría",
            PLACEHOLDER: "Selecciona categoría",
        },
        ORIGIN: {
            LABEL: "Orígen",
            PLACEHOLDER: "Selecciona orígen",
        },
        TOTAL: {
            LABEL: "Total",
            PLACEHOLDER: "0.00",
        },
        SERVICE_CATEGORY: {
            LABEL: "Categoría de Servicios",
            PLACEHOLDER: "Selecciona",
        },
    },
    MAIN_ACTION_TITLE: "Creando Registro",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    BALANCE: "Saldo:",
    CASHBOX: "Caja",
    BANK: "Banco",
    AMOUNT_MUST_BE_GT_BALANCE: "Monto debe ser menor o igual al saldo en caja",
}

export const createExpenditureRecordDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}